import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'gdp-validation-failed',
  templateUrl: './validation-failed.component.html',
  styleUrls: ['./validation-failed.component.scss']
})
export class ValidationFailedComponent implements OnInit {

  @Input() error: string;

  constructor() { }

  ngOnInit() {
  }

}
